import { gql } from '@apollo/client';

export const CREATE_ISSUE = gql`
mutation CreateIssue(
    $teamId: ID!,
    $projectIssue: String,
    $projectName: String,
    $titleIssue: String,
    $bodyIssue: String,
    $bodyUser: String,
    $sn: String,
    $sendEmail: Boolean,
  ) {
    res: createIssue(
      teamId: $teamId,
      projectIssue: $projectIssue,
      projectName: $projectName,
      titleIssue: $titleIssue,
      bodyIssue: $bodyIssue,
      bodyUser: $bodyUser,
      sn: $sn,
      sendEmail: $sendEmail,
    ) {
      issueId
    }
  }
`;
